<template>
    <div>
        <h1 class="page-header"><i class="pi pi-users"></i> Lista użytkowników organizacji partnerskich</h1>

        <div class="search-criteria" @keyup.enter="search">
            <UserSearchCriteria ref="userSearchCriteria" v-model="searchCriteria"/>

            <Toolbar>
                <template v-slot:start>
                    <Button label="Szukaj" icon="pi pi-search" @click="search"/>
                    <Button label="Wyczyść" icon="pi pi-times" @click="clear"/>
                </template>
                <template v-slot:end>
                    <div class="p-d-flex p-flex-wrap">
                        <Button label="Eksportuj dane" icon="pi pi-download" @click="exportXLSX(false)"/>
                        <Button label="Eksportuj wszystkie dane" icon="pi pi-download" @click="exportXLSX(true)"/>
                        <Button v-if="Role.isFPBZCoordinator()"
                                class="button-link" type="button" role="link"
                                icon="pi pi-plus" label="Dodaj użytkownika"
                                @click="$router.push({name: 'userCreate'})"/>
                        <Button v-if="!displayAll"
                                label="Włącz wyświetlanie wszystkich wyników"
                                class="p-button-outlined p-button-x-sm"
                                icon="pi pi-ellipsis-h" @click="toggleDisplayAll"/>
                        <Button v-if="displayAll"
                                label="Wyłącz wyświetlanie wszystkich wyników"
                                class="p-button-outlined p-button-x-sm"
                                icon="pi pi-ellipsis-h" @click="toggleDisplayAll"/>
                    </div>
                </template>
            </Toolbar>
        </div>

        <UserTable ref="userTable" :search-criteria="searchCriteria"
                   :display-all="displayAll" @loaded="loadInitialDisplayAll"
                   @sortSettingsChange="onSortSettingsChange"/>
    </div>
</template>

<script>
    import Button from "primevue/button";
    import Toolbar from "primevue/toolbar";
    import {SystemRole} from "@/utils/SystemRole";
    import {SearchCriteria} from "@/utils/SearchCriteria";
    import UserSearchCriteria from "./components/UserSearchCriteria";
    import UserTable from "./components/UserTable";

    export default {
        name: "UserListView",
        components: {
            UserTable, UserSearchCriteria, Button, Toolbar,
        },

        data() {
            return {
                searchCriteria: {
                    firstName: "",
                    lastName: "",
                    email: "",
                    systemRole: null,
                    active: true,
                    organisationId: null,
                    page: {
                        limit: 10,
                        offset: 0,
                        sortField: null,
                        sortOrder: null,
                    },
                },
                displayAll: null,
                Role: SystemRole,
            };
        },

        beforeMount() {
            SearchCriteria.loadCriteria(this);
        },

        methods: {
            search() {
                SearchCriteria.updateUrl(this);

                this.$nextTick(this.$refs.userTable.search);
            },

            clear() {
                this.searchCriteria = this.getClearSearchCriteria();
                this.search();
            },

            toggleDisplayAll() {
                this.displayAll = !this.displayAll;
                this.$cookies.set("displayAll", this.displayAll, "365d");
            },

            getClearSearchCriteria() {
                return {
                    firstName: "",
                    lastName: "",
                    email: "",
                    systemRole: null,
                    active: null,
                    organisationId: null,
                    page: this.searchCriteria.page,
                };
            },

            loadInitialDisplayAll() {
                this.displayAll = false;
                // this.displayAll = this.$cookies.get("displayAll") === "true";
            },

            onSortSettingsChange() {
                SearchCriteria.updateUrl(this);
            },

            exportXLSX(allData) {
                this.$refs.userTable.exportXLSX(allData);
            },
        },
    };
</script>

<style scoped>

</style>
